module.exports = __webpack_public_path__ + "static/media/openssidaynusharoldphotobom.95943365.jpeg";